import { createFileRoute } from '@tanstack/react-router';

// This route handles redirects for backwards compatibility purposes
export const Route = createFileRoute('/app/recurrence/create')({
  component: () => <div />,
});
